import { useState } from 'react';
import { useNavigate } from 'react-router-dom';

import { InstructionCard } from 'src/Components/Instructions/InstructionCard';
import { useCreateInstructionExport } from 'src/Hooks/Mutations/useCreateInstructionExport';
import usePrintInstruction from 'src/Hooks/Printables/usePrintInstruction';
import { useFetchAssetDetails } from 'src/Hooks/Queries/useFetchAssetDetails';
import useFetchInstructions from 'src/Hooks/Queries/useFetchInstructions';
import { useCurrentAssetId } from 'src/Hooks/Shared/useCurrentAssetId';
import { instructionsApi } from 'src/Services/API';

import styles from './InstructionList.module.scss';

const InstructionList = () => {
  const { data: instructions } = useFetchInstructions();
  const navigate = useNavigate();
  const assetId = useCurrentAssetId();
  const { data: asset } = useFetchAssetDetails();
  const { printInstruction } = usePrintInstruction();
  const [printingId, setPrintingId] = useState<string | null>(null);

  const { mutate: exportForPrint } = useCreateInstructionExport({
    onSuccess: async (data, variables) => {
      const instructionId = variables[0];
      try {
        if (!assetId) return;
        const { data: full } = await instructionsApi.instructionsControllerFindOne(
          assetId,
          instructionId
        );
        printInstruction({
          instruction: full,
          assetName: asset?.name ?? '',
          exportUrl: data.publicUrl,
        });
      } catch (error) {
        console.error('Failed to fetch instruction for printing:', error);
      } finally {
        setPrintingId(null);
      }
    },
    onError: () => setPrintingId(null),
  });

  return (
    <div className={styles.container}>
      {instructions?.map(instruction => (
        <InstructionCard
          key={instruction.id}
          title={instruction.title}
          content={instruction.content}
          imageUrl={
            instruction.attachment?.urls?.previewMediumUrl ??
            instruction.attachment?.video?.thumbnailUrl ??
            undefined
          }
          onClick={() => navigate(instruction.id)}
          onPrintClick={() => {
            setPrintingId(instruction.id);
            exportForPrint([instruction.id]);
          }}
          isPrintLoading={printingId === instruction.id}
          blurhash={instruction.attachment?.blurhash}
        />
      ))}
    </div>
  );
};

export default InstructionList;
